import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';

export default function ApiResultModal({ open, message, onClose }) {
  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Operation result</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton title="Ok" variant="primary" onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
}